import { getTimeZoneOrDefaultToUtc, normalizeTimezone } from '@vacationtracker/shared/functions/timezone'

export function resolveNotificationTimezone(userTimezone: string | undefined): string {
  if (userTimezone) return normalizeTimezone(userTimezone)
  return getTimeZoneOrDefaultToUtc()
}

export function getNotificationTimezoneFromDraftOrDefault(draftTimezone: unknown, userTimezonePreference: string | undefined): string {
  if (typeof draftTimezone === 'string' && draftTimezone) {
    return normalizeTimezone(draftTimezone)
  }
  return resolveNotificationTimezone(userTimezonePreference)
}
